import { render, staticRenderFns } from "./ClickAndBuyLogoForm.vue?vue&type=template&id=4b648429&scoped=true"
import script from "./ClickAndBuyLogoForm.vue?vue&type=script&lang=js"
export * from "./ClickAndBuyLogoForm.vue?vue&type=script&lang=js"
import style0 from "./ClickAndBuyLogoForm.vue?vue&type=style&index=0&id=4b648429&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b648429",
  null
  
)

export default component.exports